export class CustomerFilter {
  customerNumber?: string;
  type?:string;
  createdFrom?: string;
  createdTo?: string;
  createdBy?: string;
  gender?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  status?: string;
  birthDate?: string;
  phoneNumber?: string;
  street?: string;
  name?: string;
  documentType?: string;
  documentNumber?: string;
}
